<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button icon="chevron-back"></ion-back-button>
    </ion-buttons>

    <ion-title> Create a Last Minute Job </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="no-header">
  <ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <ion-col>
        <app-flex-job-info-summary></app-flex-job-info-summary>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="ion-margin">
      <app-create-job-button [queryParams]="queryParametersToLMJ"></app-create-job-button>
    </div>
  </ion-toolbar>
</ion-footer>
